
import { defineComponent } from 'vue';
import { adService } from './AdService';
import axios from 'axios';
import Multiselect from 'vue-multiselect';
import MapSearch from '@/shared/components/MapSearch.vue';
import AdList from '@/ad/components/AdList.vue';
import AdTable from '@/ad/components/AdTable.vue';
import AdListItem from '@/ad/components/AdListItem.vue';
import AdFilter from '@/ad/components/AdFilter.vue';
import GoogleAutocomplete from '@/shared/components/GoogleAutocomplete.vue';
import Pagination from '@/shared/components/AppPagination.vue';
import FooterSticky from '@/shared/components/FooterSticky.vue';
import FixedElement from '@/shared/components/FixedElement.vue';
import ResizableImage from '@/shared/components/ResizableImage.vue';
import store from '@/store';
import { estateAgentService } from '@/estate-agent/EstateAgentService';
import { urlJoin } from '@/shared/helpers/urlJoin';
import config from '@/shared/constants/config';

import { mapGetters, mapState } from 'vuex';
import { isFirefox, isEmptyObject, isNumber, isString } from '@/utils';
import { GlobalState } from '@/shared/models/GlobalState';
import { googleTagManagerService } from '@/shared/services/GoogleTagManagerService';
import { countries, defaultCountry } from '@/shared/constants/mapCountries';
import { GoogleMapLoaderService } from '@/shared/services/GoogleMapLoaderService';
import qs from 'qs';

export default defineComponent({
  name: 'AdSearch',
  inject: ['RADON_LOADING_BAR'],
  components: {
    Multiselect,
    MapSearch,
    AdList,
    AdTable,
    AdListItem,
    AdFilter,
    GoogleAutocomplete,
    Pagination,
    FooterSticky,
    FixedElement,
    ResizableImage,
  },
  props: {
    q: {
      type: String,
    },
    q2: {
      type: String,
    },
    q3: {
      type: String,
    },
  },
  data() {
    return {
      isMounted: false,
      domain: config.DOMAIN,
      defaultUrl: urlJoin(window.location.origin, config.FRONT_RELATIVE_APP_URL),
      canonicalUrl: urlJoin(window.location.origin, config.FRONT_RELATIVE_APP_URL),
      isEstateAgencyMode: config.IS_ESTATE_AGENCY_MODE,
      pageTitle: null,
      withTransition: false,
      isLoading: true,
      isCreated: false,
      isMapVisible: false,
      isInitialized: false,
      isFilterExtended: false,
      country: null,
      defaultCountry: defaultCountry,
      countries: null,
      place: null as null | any,
      filterPlace: null as null | any,
      locationFilterText: null as null,
      viewType: {},
      previousViewType: null as null | { value: string; title: string; icon: string; $isDisabled: boolean },
      mobileViewType: {},
      viewTypes: [],
      defaultViewType: 'columns',
      defaultSortBy: 'createdUtc desc',
      sortBy: {},
      sortByTypes: [] as any[],
      adFilter: {} as any,
      adFilterFrequencies: [] as null | any[],
      adTypes: [] as null | any[],
      statuses: [] as null | any[],
      estateTypes: [],
      estateSubTypes: [] as any[],
      pagedList: {
        data: [] as any[],
        page: 1,
        pageSize: 30,
        currentCount: 0,
        totalCount: 0,
      },
      agentList: [],
      markers: [],
      polylines: [],
      pageSize: 30,
      selected: null as null | any,
      hovered: null as null | any,
      prices: [0, 3500000],
      queryParams: {
        id: null as null | number,
        page: 1 as null | number,
        pageSize: 30 as null | number,
        sortBy: 'createdUtc desc' as null | string,
        type: null as null | any,
        estateFrontSubTypes: [] as any[],
        nelat: null as null | number,
        nelng: null as null | number,
        swlat: null as null | number,
        swlng: null as null | number,
        zoom: null as null | number,
        countryCode: null as null | string,
        priceFrom: null as null | number,
        priceTo: null as null | number,
        estateAreaFrom: null as null | number,
        estateAreaTo: null as null | number,
        landAreaFrom: null as null | number,
        landAreaTo: null as null | number,
        usefulAreaFrom: null as null | number,
        usefulAreaTo: null as null | number,
        hasWaterNetwork: null as null | boolean,
        hasGasNetwork: null as null | boolean,
        hasCanalizationNetwork: null as null | boolean,
        hasElectricityNetwork: null as null | boolean,
        status: null as null | any,
        floorFrom: null as null | number,
        floorTo: null as null | number,
        roomCount: null as null | number,
        hasLift: null as null | boolean,
        hasGarage: null as null | boolean,
        hasCellar: null as null | boolean,
        hasParkingPlace: null as null | boolean,
        hasBalconyLoggiaTerrace: null as null | boolean,
        isEstateAgency: null as null | boolean,
      },
      swipe: 0,
      searchCancelSource: null as any,
      bounds: null as any,
      zoom: null as null | number,
      isTableHeaderFixed: false,
      totalCountChanged: false,
      totalCountChangedTimeout: null as any,
      isFirefox: false,
      showAdFilterModal: false,
      disabledViewTypes: ['rows', 'table'],
      mapId: null,
    };
  },
  watch: {
    windowWidth: function (newVal) {
      if (this.isMobile) {
        this.swipe = 0;
        if (this.viewType !== this.mobileViewType) this.previousViewType = this.viewType;
        this.viewType = this.mobileViewType;
      } else {
        if (newVal <= 1300) {
          this.viewTypes.forEach((x) => (x.$isDisabled = this.disabledViewTypes.indexOf(x.value) > -1));

          if (this.viewType && (this.disabledViewTypes.indexOf(this.viewType.value) > -1 || this.viewType === this.mobileViewType)) {
            this.viewType = this.viewTypes.find((x) => x.value === this.defaultViewType) as any;
          }
        } else {
          this.viewTypes.forEach((x) => (x.$isDisabled = false));
          if (this.viewType === this.mobileViewType) {
            if (this.previousViewType && this.previousViewType !== this.mobileViewType) {
              this.viewType = this.previousViewType;
            } else {
              this.viewType = this.viewTypes.find((x) => x.value === this.defaultViewType) as any;
            }
          }
        }
      }
    },
    isLoggedIn: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.search(false, false);
      }
    },
    sortBy: {
      handler: function (newVal) {
        if (newVal.value != this.queryParams.sortBy) {
          this.sortByColumn(newVal.value);
        }
      },
    },
    viewType: {
      handler: function (val) {
        let existsSortBy = this.sortByTypes.find((x) => x.value === this.queryParams.sortBy);
        if (existsSortBy) {
          this.sortBy = existsSortBy;
        } else {
          let found = this.sortByTypes.find((x) => x.value === this.defaultSortBy);
          if (found) {
            this.sortBy = found;
            this.sortByColumn(this.sortBy.value);
          }
        }
        this.$store.commit('searchAdsViewType', val.value);
      },
    },
    queryParams: {
      handler: function () {
        if (this.$refs.btnSearch) {
          (this.$refs.btnSearch as any).classList.add('shine-effect');
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.isMounted = true;
  },
  async created() {
    this.pageTitle = this.$t('AdSearch.title-custom');
    this.country = defaultCountry;
    this.countries = [defaultCountry, ...countries.filter((x) => x.key !== defaultCountry.key)];
    this.sortByTypes = adService.getSortByTypes(this.$t);
    this.sortBy = this.sortByTypes[0];
    this.viewTypes = [
      { value: 'columns', title: this.$t('AdSearch.view-types.columns'), icon: 'icon-show-columns', $isDisabled: false },
      { value: 'rows', title: this.$t('AdSearch.view-types.rows'), icon: 'icon-show-rows', $isDisabled: false },
      { value: 'table', title: this.$t('AdSearch.view-types.table'), icon: 'icon-show-table', $isDisabled: false },
      { value: 'fullscreen', title: this.$t('AdSearch.view-types.fullscreen'), icon: 'icon-show-fullscreen', $isDisabled: false },
    ];
    this.viewType = this.viewTypes[0];
    (this.mobileViewType = { value: 'mobile', title: this.$t('AdSearch.view-types.mobile'), icon: 'icon-show-rows', $isDisabled: false }),
      (this.isFirefox = isFirefox());
    if (this.isMobile) {
      this.swipe = 2;
      this.viewType = this.mobileViewType;
    }

    try {
      this.adFilter = (await adService.getFilter({ adFilterId: this.$route.query.adFilterId })).data;

      this.adFilterFrequencies = this.adFilter.adFilterFrequencies;

      if (!this.adTypes) this.adTypes = [];
      this.adTypes.push(...this.adFilter.adTypes);

      if (!this.statuses) this.statuses = [];
      this.statuses.push({ key: null, value: this.$t('select.all') });
      this.statuses.push(...this.adFilter.statuses);

      this.estateTypes = this.adFilter.estateTypes;

      for (let item of this.estateTypes) {
        this.estateSubTypes.push(...(item as any).estateSubTypes);
      }

      let queryParams = null;

      if (this.adFilter.filter) {
        queryParams = JSON.parse(this.adFilter.filter);
      } else {
        if (!isEmptyObject(this.$route.query) || this.q || this.q2 || this.q3) {
          queryParams = qs.parse(window.location.search.substring(1));
          await this.handleRouteParams(queryParams);
        } else if (this.$store.state.adSearchParams) {
          queryParams = this.$store.state.adSearchParams as any;
        }
      }
      await this.initQueryParams(queryParams);

      let viewType = queryParams.viewType ? queryParams.viewType : this.$store.state.adSearchViewType;
      if (viewType) {
        queryParams.viewType = null;
        const foundViewType = this.viewTypes.filter((x) => x.value == viewType);
        if (foundViewType.length > 0) this.viewType = foundViewType[0];
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.isCreated = true;
      this.isMapVisible = true;
    }
  },
  computed: {
    ...mapGetters(['isMobile', 'isLoggedIn', 'windowWidth', 'windowHeight']),
    ...mapState({
      user: (state) => (state as GlobalState).user,
    }),
    layoutClass(): any {
      return {
        'layout_estate-map-filter': !this.isEstateAgencyMode && (!this.user || !this.user.settings || this.user.settings.adSearchLayout === 1),
        'layout_filter-map-estate': this.isEstateAgencyMode || (this.user && this.user.settings && this.user.settings.adSearchLayout === 2),
      };
    },
    metaDescription(): string {
      return this.pageTitle + ' ' + this.$t('AdSearch.metaDescription', { domain: this.domain });
    },
    mapHeightStyle(): string {
      return this.isMobile ? this.windowHeight - 75 - 67 + 'px' : 'auto';
    },
    pageCount(): number {
      return Math.ceil(this.pagedList.data.length / this.pageSize);
    },
    highlighted(): null | any {
      return this.hovered ? this.hovered : this.selected;
    },
    showList(): boolean {
      return !this.isMobile || this.swipe === 0;
    },
    isFullScreen(): boolean {
      return this.viewType.value === 'fullscreen';
    },
    showMap(): boolean {
      // if (this.viewType.value === 'fullscreen') {
      //   return false;
      // } else if (this.isMobile) {
      //   return true;
      // }
      return true;
    },
    showFilter(): boolean {
      return !this.isMobile || this.swipe === 2;
    },
    showTable(): boolean {
      return this.viewType.value === 'table';
    },
    viewClass(): string {
      return 'view-' + this.viewType.value;
    },
    adListClass(): string {
      return 'estate-listing--' + this.viewType.value;
    },
    canUnzoom(): boolean {
      return this.$refs.map && (this.$refs.map as any).canUnzoom();
    },
    showZoomAdsControls(): boolean {
      return this.viewType.value !== 'table' && !this.isFirefox;
    },
    isFlat(): boolean {
      return (
        this.queryParams.estateFrontSubTypes &&
        this.queryParams.estateFrontSubTypes.length > 0 &&
        this.queryParams.estateFrontSubTypes.every((x) => x.key > 100 && x.key < 200)
      );
    },
    isHouse(): boolean {
      return (
        this.queryParams.estateFrontSubTypes &&
        this.queryParams.estateFrontSubTypes.length > 0 &&
        this.queryParams.estateFrontSubTypes.every((x) => x.key > 200 && x.key < 300)
      );
    },
    isLand(): boolean {
      return (
        this.queryParams.estateFrontSubTypes &&
        this.queryParams.estateFrontSubTypes.length > 0 &&
        this.queryParams.estateFrontSubTypes.every((x) => x.key > 300 && x.key < 400)
      );
    },
    filterCount(): number {
      let count = 0;
      if (this.place || this.filterPlace) count++;
      if (this.queryParams.type != null) count++;
      if (this.queryParams.estateFrontSubTypes && this.queryParams.estateFrontSubTypes.length > 0) count += this.queryParams.estateFrontSubTypes.length;
      if (this.queryParams.priceFrom != null && this.queryParams.priceFrom > 0) count++;
      if (this.queryParams.priceTo != null && this.queryParams.priceTo > 0) count++;
      if (this.queryParams.isEstateAgency != null) count++;
      if (this.queryParams.countryCode && this.queryParams.countryCode != defaultCountry.key) count++;

      if (this.isFlat) {
        if (this.queryParams.status != null && this.queryParams.status.key != null) count++;
        if (this.queryParams.estateAreaFrom != null && this.queryParams.estateAreaFrom > 0) count++;
        if (this.queryParams.estateAreaTo != null && this.queryParams.estateAreaTo > 0) count++;
        if (this.queryParams.floorFrom != null && this.queryParams.floorFrom > 0) count++;
        if (this.queryParams.floorTo != null && this.queryParams.floorTo > 0) count++;
        if (this.queryParams.hasLift === true) count++;
        if (this.queryParams.hasParkingPlace === true) count++;
        if (this.queryParams.hasBalconyLoggiaTerrace === true) count++;
        if (this.queryParams.hasCellar === true) count++;
      } else if (this.isHouse) {
        if (this.queryParams.status != null && this.queryParams.status.key != null) count++;
        if (this.queryParams.usefulAreaFrom != null && this.queryParams.usefulAreaFrom > 0) count++;
        if (this.queryParams.usefulAreaTo != null && this.queryParams.usefulAreaTo > 0) count++;
        if (this.queryParams.landAreaFrom != null && this.queryParams.landAreaFrom > 0) count++;
        if (this.queryParams.landAreaTo != null && this.queryParams.landAreaTo > 0) count++;
        if (this.queryParams.roomCount != null && this.queryParams.roomCount > 0) count++;
        if (this.queryParams.hasGarage === true) count++;
        if (this.queryParams.hasCellar === true) count++;
      } else if (this.isLand) {
        if (this.queryParams.landAreaFrom != null && this.queryParams.landAreaFrom > 0) count++;
        if (this.queryParams.landAreaTo != null && this.queryParams.landAreaTo > 0) count++;
        if (this.queryParams.hasWaterNetwork === true) count++;
        if (this.queryParams.hasGasNetwork === true) count++;
        if (this.queryParams.hasCanalizationNetwork === true) count++;
        if (this.queryParams.hasElectricityNetwork === true) count++;
      }

      return count;
    },
    hasFilter(): boolean {
      return this.filterCount > 0;
    },
    windowTitle(): string {
      return this.pageTitle + ' ' + this.$t('AdSearch.title-suffix', { domain: this.domain });
    },
  },
  methods: {
    onViewTypeSelect(val) {
      if (!val) return;
      if (val.value === 'columns') {
        googleTagManagerService.send({
          event: 'stlpce_zobrazenie',
        });
      } else if (val.value === 'rows') {
        googleTagManagerService.send({
          event: 'riadky_zobrazenie',
        });
      } else if (val.value === 'fullscreen') {
        googleTagManagerService.send({
          event: 'bezmapy_zobrazenie',
        });
      } else if (val.value === 'table') {
        googleTagManagerService.send({
          event: 'tabulka_zobrazenie',
        });
      }
    },
    onSortBySelect(val) {
      if (!val) return;
      if (val.value === 'createdUtc desc') {
        googleTagManagerService.send({
          event: 'stlpce_zobrazenie',
        });
      } else if (val.value === 'createdUtc') {
        googleTagManagerService.send({
          event: 'najstarsie_zoradenie',
        });
      } else if (val.value === 'price') {
        googleTagManagerService.send({
          event: 'najlacnejsie_zoradenie',
        });
      } else if (val.value === 'price desc') {
        googleTagManagerService.send({
          event: 'najdrahsie_zoradenie',
        });
      } else if (val.value === 'likeCount desc') {
        googleTagManagerService.send({
          event: 'najpopularnejsie_zoradenie',
        });
      }
    },
    async handleRouteParams(params) {
      let isHandled = this.handleRouteParam(this.q, params);
      if (!isHandled) {
        try {
          const location = await adService.getLocation({ code: this.q });
          if (location.status === 200 && location.data) {
            params.place_id = location.data.placeId;
          }
        } catch {
          //
        }
      }
      this.handleRouteParam(this.q2, params);
      this.handleRouteParam(this.q3, params);
    },
    handleRouteParam(param, params) {
      if (!param) return true;

      let adType = this.adFilter.adTypes.find((x) => x.code === param);
      if (adType) {
        params.type = adType.key;
        return true;
      }

      for (let estateType of this.adFilter.estateTypes) {
        let estateSubType = estateType.estateSubTypes.find((x) => x.code === param);
        if (estateSubType) {
          params.estateFrontSubTypes = [estateSubType.key];
          return true;
        }
      }
      return false;
    },
    async initQueryParams(params) {
      if (!params) params = {};

      if (params.estateFrontSubTypes && params.estateFrontSubTypes.length > 0) {
        for (let i = 0; i < params.estateFrontSubTypes.length; i++) {
          let type = this.estateSubTypes.find((x) => (x as any).key === +params.estateFrontSubTypes[i]);
          if (type) {
            params.estateFrontSubTypes[i] = type;
          }
        }
      }
      if (isNumber(params.type)) params.type = +params.type;
      else params.type = null;
      if (isNumber(params.page)) params.page = +params.page;
      else params.page = null;
      if (isNumber(params.pageSize)) params.pageSize = +params.pageSize;
      else params.pageSize = null;
      if (isNumber(params.priceFrom)) params.priceFrom = +params.priceFrom;
      else params.priceFrom = null;
      if (isNumber(params.priceTo)) params.priceTo = +params.priceTo;
      else params.priceTo = null;
      if (isNumber(params.status)) {
        const status = this.statuses.filter((x) => x.key === +params.status);
        if (status.length > 0) params.status = status[0];
      } else params.status = null;

      const sortByType = this.sortByTypes.filter((x) => x.value == params.sortBy);
      if (sortByType.length > 0) this.sortBy = sortByType[0];
      else params.sortBy = this.defaultSortBy;

      if (params.swlat || params.swlng || params.nelat || params.nelng) {
        if (isNumber(params.swlat) && isNumber(params.swlng) && isNumber(params.nelat) && isNumber(params.nelng)) {
          this.bounds = {
            swlat: +params.swlat,
            swlng: +params.swlng,
            nelat: +params.nelat,
            nelng: +params.nelng,
          };
        } else {
          params.swlat = null;
          params.swlng = null;
          params.nelat = null;
          params.nelng = null;
        }
      }

      if (params.zoom) {
        if (isNumber(params.zoom)) {
          this.zoom = params.zoom = +params.zoom;
        } else {
          params.zoom = null;
        }
      }

      if (params.countryCode) {
        this.country = this.countries.find((x) => x.key === params.countryCode);
        if (!this.country) params.countryCode = null;
      }

      if (params.place_id) {
        await GoogleMapLoaderService.load();
        let place = await adService.getPlace(params.place_id);
        if (place) {
          this.$refs.place.setPlace(place);
        }
      }

      this.queryParams = params;
    },
    sortByColumn(value: string) {
      this.queryParams.sortBy = value;
      this.search(true, false);
    },
    selectAdType(value: number) {
      if (this.queryParams.type === value) this.queryParams.type = null;
      else this.queryParams.type = value;
    },
    filterToggle(value: boolean) {
      this.isFilterExtended = value;
    },
    zoomAdsIn() {
      this.zoomAds(0.1);
    },
    zoomAdsOut() {
      this.zoomAds(-0.1);
    },
    zoomAds(zoomChange: number) {
      const el = (this.$refs.estateListing as any).$el;
      if (el) {
        if (!el.style.zoom) {
          el.style.zoom = 1;
        }

        if (zoomChange > 0) {
          if (el.style.zoom < 1.5) {
            el.style.zoom = +el.style.zoom + zoomChange;
            store.dispatch('zoomAds', el.style.zoom);
          }
        } else {
          if (el.style.zoom > 0.5) {
            el.style.zoom = +el.style.zoom + zoomChange;
            store.dispatch('zoomAds', el.style.zoom);
          }
        }
      }
    },
    updateTableFixedStatus(isFixed: boolean) {
      this.isTableHeaderFixed = isFixed;
    },
    pageChangeHandle(value: number, scroll: boolean) {
      this.queryParams = Object.assign({}, this.queryParams, { page: value });
      this.search(true, false);
      if (scroll) {
        const el = this.$el.parentNode.getElementsByClassName('estate-listing-filter')[0];

        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    },
    cancelSearch() {
      if (this.searchCancelSource) {
        this.searchCancelSource.cancel('Start new search, stop active search');
      }
    },
    getSearchParams() {
      const zoom = (this.$refs.map as any)?.getZoom();
      if (zoom) {
        this.queryParams.zoom = zoom;
      }

      this.queryParams.countryCode = this.country.key;

      const params = Object.assign({}, this.queryParams);

      if (params.status && params.status.key) {
        params.status = params.status.key;
      } else {
        params.status = null;
      }
      if (params.estateFrontSubTypes && params.estateFrontSubTypes.length > 0) {
        params.estateFrontSubTypes = params.estateFrontSubTypes.map((x) => x.key);
      }

      if (this.place && this.place.placeResult && this.place.placeResult.place_id) {
        params.place_id = this.place.placeResult.place_id;
      } else {
        params.place_id = null;
      }
      return params;
    },
    async search(skipMarkers: boolean, isSelectedChange: boolean) {
      try {
        if (!this.isCreated) return;

        this.cancelSearch();
        this.searchCancelSource = axios.CancelToken.source();
        this.isLoading = true;

        let params = this.getSearchParams();
        if (isSelectedChange && this.selected) {
          params.id = this.selected.adId;
        } else {
          params.id = null;
        }
        await this.saveParamsToUrl(Object.assign({}, params));
        this.$store.commit('searchAds', params);
        const serverParams = Object.assign({}, params, { countryCode: null });
        const result = await adService.get(serverParams, this.searchCancelSource.token);
        if (!skipMarkers && params.zoom) {
          const markerParams = Object.assign({}, serverParams);
          markerParams.page = null;
          markerParams.pageSize = null;
          markerParams.sortBy = null;
          markerParams.id = null;
          const markerResult = await adService.getMarkers(markerParams, this.searchCancelSource.token);
          this.markers = markerResult.data.markers;
          this.polylines = markerResult.data.polylines;
        }
        if (this.selected) {
          const exists = result.data.data.some((item: any) => item.adId === this.selected.adId);
          if (!exists) {
            this.selected = null;
          }
        }
        if (!this.selected && result.data.data.length > 0) {
          this.selected = result.data.data[0];
        }
        const totalCountChanged = result.data.totalCount !== this.pagedList.totalCount;
        this.pagedList = result.data;
        if (!skipMarkers) {
          const agentListResult = await estateAgentService.getMapList(serverParams, this.searchCancelSource.token);
          this.agentList = agentListResult.data;
        }
        if (totalCountChanged) {
          if (this.totalCountChangedTimeout) {
            clearTimeout(this.totalCountChangedTimeout);
          }
          this.totalCountChanged = true;
          this.totalCountChangedTimeout = setTimeout(() => (this.totalCountChanged = false), 4200);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
        //this.handleApiError(error);
      } finally {
        this.isLoading = false;
        this.isInitialized = true;
      }
    },
    async saveParamsToUrl(searchParams) {
      searchParams.place_id = null;
      let result = await adService.getParamsToUrl(searchParams, this.place, this.adFilter);
      const { href } = this.$router.resolve(result.routerParams);
      this.canonicalUrl = urlJoin(config.BASE_URL, href);
      this.generateTitle(result.titleParams);
      window.history.replaceState({}, '', `${href}?${result.qsString}`);
    },
    generateTitle(params) {
      if (params.location && params.adType && params.estateType) {
        this.pageTitle = this.$t('AdSearch.title-1', {
          location: params.location.title,
          adType: params.adType.value.toLowerCase(),
          estateType: params.estateType.description,
        });
      } else if (params.location && params.adType) {
        if (params.adType.key === 3) {
          this.pageTitle = this.$t('AdSearch.title-2', {
            location: params.location.title,
            adType: params.adType.value,
          });
        } else {
          this.pageTitle = this.$t('AdSearch.title-3', {
            location: params.location.title,
            adType: params.adType.value,
          });
        }
      } else if (params.location && params.estateType) {
        this.pageTitle = this.$t('AdSearch.title-4', {
          location: params.location.title,
          estateType: params.estateType.description,
        });
      } else if (params.adType && params.estateType) {
        this.pageTitle = this.$t('AdSearch.title-5', {
          adType: params.adType.value.toLowerCase(),
          estateType: params.estateType.description,
        });
      } else if (params.location) {
        this.pageTitle = this.$t('AdSearch.title-6', {
          location: params.location.title,
        });
      } else if (params.adType) {
        this.pageTitle = this.$t('AdSearch.title-7', {
          adType: params.adType.value.toLowerCase(),
        });
      } else if (params.estateType) {
        this.pageTitle = `${params.estateType.description}`;
      } else {
        this.pageTitle = this.$t('AdSearch.title-custom');
      }
    },
    async onBoundsChanged(bounds: any | null | undefined, isFilterByPlace: boolean) {
      if (bounds) {
        this.queryParams.nelat = bounds.getNorthEast().lat();
        this.queryParams.nelng = bounds.getNorthEast().lng();
        this.queryParams.swlat = bounds.getSouthWest().lat();
        this.queryParams.swlng = bounds.getSouthWest().lng();
        this.queryParams.page = 1;
        if (isFilterByPlace && !this.locationFilterText && this.place && this.place.placeResult) {
          this.locationFilterText = this.place.placeResult.formatted_address;
        } else if (!isFilterByPlace && !this.isMobile) {
          this.place = null;
          this.locationFilterText = null;
        }
        this.filter(isFilterByPlace);
      }
    },
    onMapSelected(ad: any) {
      this.selected = ad;
      this.goToAd(ad);
    },
    async goToAd(ad: any) {
      const isInPage = this.pagedList.data.filter((x) => x.adId === ad.adId).length > 0;
      if (isInPage) {
        this.scrollToAd(ad);
      } else {
        await this.search(true, true);
        this.scrollToAd(ad);
      }
    },
    scrollToAd(ad: any) {
      const el = this.$el.parentNode.getElementsByClassName('estate-listing-' + ad.adId)[0];

      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
    onSelected(ad: any) {
      this.selected = ad;
    },
    onHover(ad: any) {
      this.hovered = ad;
    },
    onPlaceChanged(address: any, placeResult: any) {
      if (address && placeResult) {
        this.filterPlace = {
          address,
          placeResult,
        };
      } else {
        this.place = null;
        this.filterPlace = null;
      }
    },
    forceShowList(withTransition = false) {
      this.swipe = 0;
      this.withTransition = withTransition;
    },
    forceShowMap() {
      this.swipe = 1;
      this.withTransition = false;
    },
    forceShowFilter() {
      this.swipe = 2;
      this.withTransition = false;
    },
    filter(isFormSubmit = false) {
      if (this.filterPlace) {
        this.queryParams.countryCode = this.country.key;
        this.place = this.filterPlace;
        this.filterPlace = null;
        (this.$refs.map as any).filterByPlace(this.place.placeResult);
        return;
      }
      if (!this.queryParams.countryCode || this.queryParams.countryCode !== this.country.key) {
        this.queryParams.countryCode = this.country.key;
        (this.$refs.map as any).setCountry(this.country.key);

        if (this.isInitialized) {
          return;
        }
      }
      this.search(false, false);
      if (isFormSubmit && this.isMobile) {
        this.forceShowList(true);
      }
    },
    clearFilter() {
      this.filterPlace = null;
      this.place = null;
      this.locationFilterText = null;
      this.country = defaultCountry;
      this.queryParams = Object.assign({}, this.queryParams, {
        type: null,
        estateFrontSubTypes: [],
        countryCode: null,
        priceFrom: null,
        priceTo: null,
        estateAreaFrom: null,
        estateAreaTo: null,
        landAreaFrom: null,
        landAreaTo: null,
        usefulAreaFrom: null,
        usefulAreaTo: null,
        hasWaterNetwork: null,
        hasGasNetwork: null,
        hasCanalizationNetwork: null,
        hasElectricityNetwork: null,
        status: null,
        floorFrom: null,
        floorTo: null,
        roomCount: null,
        hasLift: null,
        hasGarage: null,
        hasCellar: null,
        hasParkingPlace: null,
        hasBalconyLoggiaTerrace: null,
        isEstateAgency: null,
      });

      if (this.isMobile) {
        this.forceShowFilter();
      }
    },
    unzoomMap() {
      if (this.$refs.map) {
        (this.$refs.map as any).unzoom();
      }

      if (this.isMobile) {
        this.forceShowMap();
      }
    },
  },
});
